import styled from 'styled-components';

// Images
import LinkedinLogoSource from '../../../images/linkedin-footer.svg';

const LinkedinLogo = styled(LinkedinLogoSource)`
  max-width: 100%;
  height: auto;

  path {
    fill: var(--colors-mischka);
    fill-opacity: 0.7;
  }
`;

export default LinkedinLogo;
